import { Button } from '@mui/material'
import { useVesselVisitBreadcrumbs } from '@operations/hooks/useVesselVisitBreadcrumbs'
import { CarrierVisitStore } from '@operations/stores/CarrierVisitStore'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { Breadcrumbs } from 'modules/ui/src/theme/components/breadcrumbs/Breadcrumb'
import { useNavigate } from 'react-router'
import { StoppageViewUIStore } from '../../stores/stoppage-view.ui-store'

interface Props {
  visitId: number
  carrierVisitStore: CarrierVisitStore
  stoppageViewUIStore: StoppageViewUIStore
}
export const StoppagesHeader = observer(
  ({ visitId, carrierVisitStore, stoppageViewUIStore }: Props) => {
    const navigate = useNavigate()
    const { t } = useTranslate()
    const title = t('stoppage', 'Stoppage')

    const vesselVisit = carrierVisitStore.items.find(vesselVisit => vesselVisit.id === visitId)
    const { breadcrumbs } = useVesselVisitBreadcrumbs(vesselVisit)

    return (
      <>
        <Breadcrumbs items={breadcrumbs} />
        <Header
          title={title}
          position='relative'
          enableSearchField
          displaySearchIcon
          searchInputLabel={t('searchForAName', 'Search for a name')}
          onSearchFieldChange={value => stoppageViewUIStore.setSearchTerm(value)}
          rightRenderOption={
            <Button
              variant='contained'
              color='primary'
              data-cy='add-new-stoppage-btn'
              sx={{ flex: 'none' }}
              onClick={() =>
                navigate(
                  `${PATHS.visits.vesselVisits.url}/${visitId}/${PATHS.visits.vesselVisits.stoppages.url}/new`,
                )
              }
            >
              {t('record', 'Record')}
            </Button>
          }
        />
      </>
    )
  },
)
